import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
  request.get('/api/inspectPlanAndProject/list', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
  request.get('/api/inspectPlanAndProject/detail', Object.assign({}, options, { params }));

export const remove = (params, options) =>
  request.post('/api/inspectPlanAndProject/remove', qs.stringify(params), options);

export const add = (params, options) =>
  request.post('/api/inspectPlanAndProject/submit', params, options);

export const update = (params, options) =>
  request.post('/api/inspectPlanAndProject/submit', params, options);
export const getInspectPlanAndProjectList = (params, options) =>
  request.get(
    '/api/inspectPlanAndProject/getInspectPlanAndProjectList',
    Object.assign({}, options, { params })
  );
